export function initContactForm(form, { fetcher = globalThis.fetch, timers = globalThis, closeDialog = (dialog) => dialog.close() } = {}) {
  const button = form.querySelector('[type="submit"]');
  const fields = form.querySelector('fieldset');
  const feedback = form.querySelector('[data-contact-feedback]');
  const thanks = form.querySelector('[data-contact-thanks]');
  const dialog = form.closest('dialog');
  const initialFeedback = feedback.textContent;
  let token;
  let pending = false;
  let disposed = false;
  let completed = false;
  let closeTimer;
  let session = 0;
  const clearThanks = () => {
    timers.clearTimeout(closeTimer);
    closeTimer = undefined;
    dialog.classList.remove('is-contact-sent');
    thanks.hidden = true;
    if (completed) feedback.textContent = initialFeedback;
    completed = false;
    button.disabled = pending || disposed;
  };
  const onClose = () => {
    session++;
    clearThanks();
  };
  const controller = new AbortController();
  const request = async (options) => {
    const response = await fetcher(form.action, {
      credentials: 'same-origin', cache: 'no-store', signal: controller.signal, ...options,
    });
    const data = await response.json();
    if (!response.ok || data.ok !== true) {
      if (response.status === 403 || response.status === 409) token = undefined;
      throw new Error(data.message || '送信できませんでした。');
    }
    return data;
  };
  const submit = async (event) => {
    event.preventDefault();
    if (pending || completed || disposed || !form.reportValidity()) return;
    const submittedSession = session;
    const values = Object.fromEntries(new FormData(form));
    pending = true;
    fields.disabled = true;
    button.disabled = true;
    feedback.textContent = '送信しています…';
    try {
      if (!token) {
        const data = await request({ method: 'GET' });
        if (typeof data.token !== 'string' || !/^[a-f0-9]{64}$/.test(data.token)) throw new Error('送信の準備ができませんでした。');
        token = data.token;
      }
      if (disposed) return;
      const data = await request({
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...values, token }),
      });
      if (disposed) return;
      token = undefined;
      form.reset();
      feedback.textContent = data.message;
      if (dialog.open && session === submittedSession) {
        completed = true;
        dialog.classList.add('is-contact-sent');
        thanks.hidden = false;
        thanks.focus({ preventScroll: true });
        closeTimer = timers.setTimeout(() => {
          closeTimer = undefined;
          if (!disposed && completed && session === submittedSession && dialog.open) closeDialog(dialog);
        }, 3000);
      }
    } catch (error) {
      if (disposed) return;
      feedback.textContent = error instanceof SyntaxError || error instanceof TypeError
        ? '送信結果を確認できませんでした。入力内容は残しています。時間をおいて再度お試しいただくか、メールでご連絡ください。'
        : error.message;
    } finally {
      pending = false;
      fields.disabled = false;
      button.disabled = disposed || completed;
    }
  };
  button.disabled = false;
  form.addEventListener('submit', submit);
  dialog.addEventListener('close', onClose);
  return () => {
    disposed = true;
    clearThanks();
    controller.abort();
    form.removeEventListener('submit', submit);
    dialog.removeEventListener('close', onClose);
    fields.disabled = false;
    button.disabled = true;
  };
}
